const areas = {
  "ja": [
    {label: "国内", value: 1},
    {label: "国外", value: 2}
  ],
  "en": [
    {label: "Japan", value: 1},
    {label: "Other countries", value: 2}
  ]
};

const partners = [{ label: "有", value: 1 }, { label: "無", value: 0 }];

const languages = {
  "ja": [
    { label: "日本語", value: 1 },
    { label: "英語", value: 2 },
    { label: "中国語", value: 3 },
    { label: "その他", value: 99 },
  ],
  "en": [
    { label: "Japanese", value: 1 },
    { label: "English", value: 2 },
    { label: "Chinese", value: 3 },
    { label: "Other", value: 99 },
  ]
};

const countries = [
  { label: "Afghanistan", value: 1 },
  { label: "Albania", value: 2 },
  { label: "Algeria", value: 3 },
  { label: "Andorra", value: 4 },
  { label: "Angola", value: 5 },
  { label: "Antigua and Barbuda", value: 6 },
  { label: "Argentina", value: 7 },
  { label: "Armenia", value: 8 },
  { label: "Australia", value: 9 },
  { label: "Austria", value: 10 },
  { label: "Azerbaijan", value: 11 },
  { label: "Bahamas", value: 12 },
  { label: "Bahrain", value: 13 },
  { label: "Bangladesh", value: 14 },
  { label: "Barbados", value: 15 },
  { label: "Belarus", value: 16 },
  { label: "Belgium", value: 17 },
  { label: "Belize", value: 18 },
  { label: "Benin", value: 9 },
  { label: "Bhutan", value: 20 },
  { label: "Bolivia, Plurinational State of", value: 21 },
  { label: "Bosnia and Herzegovina", value: 22 },
  { label: "Botswana", value: 23 },
  { label: "Brazil", value: 24 },
  { label: "Brunei Darussalam", value: 25 },
  { label: "Bulgaria", value: 26 },
  { label: "Burkina Faso", value: 27 },
  { label: "Burundi", value: 28 },
  { label: "Cambodia", value: 29 },
  { label: "Cameroon", value: 30 },
  { label: "Canada", value: 31 },
  { label: "Cape Verde", value: 32 },
  { label: "Central African Republic", value: 33 },
  { label: "Chad", value: 34 },
  { label: "Chile", value: 35 },
  { label: "China", value: 36 },
  { label: "Colombia", value: 37 },
  { label: "Comoros", value: 38 },
  { label: "Congo", value: 39 },
  { label: "Congo, the Democratic Republic of the", value: 40 },
  { label: "Cook Islands", value: 41 },
  { label: "Costa Rica", value: 42 },
  { label: "Côte d'Ivoire", value: 43 },
  { label: "Croatia", value: 44 },
  { label: "Cuba", value: 45 },
  { label: "Cyprus", value: 46 },
  { label: "Czechia", value: 47 },
  { label: "Denmark", value: 48 },
  { label: "Djibouti", value: 49 },
  { label: "Dominica", value: 50 },
  { label: "Dominican Republic", value: 51 },
  { label: "Ecuador", value: 52 },
  { label: "Egypt", value: 53 },
  { label: "El Salvador", value: 54 },
  { label: "Equatorial Guinea", value: 55 },
  { label: "Eritrea", value: 56 },
  { label: "Estonia", value: 57 },
  { label: "Ethiopia", value: 58 },
  { label: "Fiji", value: 59 },
  { label: "Finland", value: 60 },
  { label: "France", value: 61 },
  { label: "Gabon", value: 62 },
  { label: "Gambia", value: 63 },
  { label: "Georgia", value: 64 },
  { label: "Germany", value: 65 },
  { label: "Ghana", value: 66 },
  { label: "Greece", value: 67 },
  { label: "Grenada", value: 68 },
  { label: "Guatemala", value: 69 },
  { label: "Guinea", value: 70 },
  { label: "Guinea-Bissau", value: 71 },
  { label: "Guyana", value: 72 },
  { label: "Haiti", value: 73 },
  { label: "Holy See (Vatican City State)", value: 74 },
  { label: "Honduras", value: 75 },
  { label: "Hungary", value: 76 },
  { label: "Iceland", value: 77 },
  { label: "India", value: 78 },
  { label: "Indonesia", value: 79 },
  { label: "Iran, Islamic Republic of", value: 80 },
  { label: "Iraq", value: 81 },
  { label: "Ireland", value: 82 },
  { label: "Israel", value: 83 },
  { label: "Italy", value: 84 },
  { label: "Jamaica", value: 85 },
  { label: "Japan", value: 86 },
  { label: "Jordan", value: 87 },
  { label: "Kazakhstan", value: 88 },
  { label: "Kenya", value: 89 },
  { label: "Kiribati", value: 90 },
  { label: "Korea, Democratic People's Republic of", value: 91 },
  { label: "Korea, Republic of", value: 92 },
  { label: "Kosovo", value: 93 },
  { label: "Kuwait", value: 94 },
  { label: "Kyrgyzstan", value: 95 },
  { label: "Lao People's Democratic Republic", value: 96 },
  { label: "Latvia", value: 97 },
  { label: "Lebanon", value: 98 },
  { label: "Lesotho", value: 99 },
  { label: "Liberia", value: 100 },
  { label: "Libya", value: 101 },
  { label: "Liechtenstein", value: 102 },
  { label: "Lithuania", value: 103 },
  { label: "Luxembourg", value: 104 },
  { label: "Macedonia, the former Yugoslav Republic", value: 105 },
  { label: "Madagascar", value: 106 },
  { label: "Malawi", value: 107 },
  { label: "Malaysia", value: 108 },
  { label: "Maldives", value: 109 },
  { label: "Mali", value: 110 },
  { label: "Malta", value: 111 },
  { label: "Marshall Islands", value: 112 },
  { label: "Mauritania", value: 113 },
  { label: "Mauritius", value: 114 },
  { label: "Mexico", value: 115 },
  { label: "Micronesia, Federated States of", value: 116 },
  { label: "Moldova, Republic of", value: 117 },
  { label: "Monaco", value: 118 },
  { label: "Mongolia", value: 119 },
  { label: "Montenegro", value: 120 },
  { label: "Morocco", value: 121 },
  { label: "Mozambique", value: 122 },
  { label: "Myanmar", value: 123 },
  { label: "Nagorno Karabagh Republic", value: 124 },
  { label: "Namibia", value: 125 },
  { label: "Nauru", value: 126 },
  { label: "Nepal", value: 127 },
  { label: "Netherlands", value: 128 },
  { label: "New Zealand", value: 129 },
  { label: "Nicaragua", value: 130 },
  { label: "Niger", value: 131 },
  { label: "Nigeria", value: 132 },
  { label: "Niue", value: 133 },
  { label: "Northern Cyprus", value: 134 },
  { label: "Norway", value: 135 },
  { label: "Oman", value: 136 },
  { label: "Pakistan", value: 137 },
  { label: "Palau", value: 138 },
  { label: "Palestinian Territory, Occupied", value: 139 },
  { label: "Panama", value: 140 },
  { label: "Papua New Guinea", value: 141 },
  { label: "Paraguay", value: 142 },
  { label: "Peru", value: 143 },
  { label: "Philippines", value: 144 },
  { label: "Poland", value: 145 },
  { label: "Portugal", value: 146 },
  { label: "Pridnestrovian Moldavian Republic", value: 147 },
  { label: "Qatar", value: 148 },
  { label: "Romania", value: 149 },
  { label: "Russian Federation", value: 159 },
  { label: "Rwanda", value: 151 },
  { label: "Saint Kitts and Nevis", value: 152 },
  { label: "Saint Lucia", value: 153 },
  { label: "Saint Vincent and the Grenadines", value: 154 },
  { label: "Samoa", value: 155 },
  { label: "San Marino", value: 156 },
  { label: "Sao Tome and Principe", value: 157 },
  { label: "Saudi Arabia", value: 158 },
  { label: "Senegal", value: 159 },
  { label: "Serbia", value: 160 },
  { label: "Seychelles", value: 161 },
  { label: "Sierra Leone", value: 162 },
  { label: "Singapore", value: 163 },
  { label: "Slovakia", value: 164 },
  { label: "Slovenia", value: 165 },
  { label: "Solomon Islands", value: 166 },
  { label: "Somalia", value: 167 },
  { label: "Somaliland, Republic of", value: 168 },
  { label: "South Africa", value: 169 },
  { label: "South Ossetia", value: 170 },
  { label: "South Sudan", value: 171 },
  { label: "Spain", value: 172 },
  { label: "Sri Lanka", value: 173 },
  { label: "Sudan", value: 174 },
  { label: "Suriname", value: 175 },
  { label: "Swaziland", value: 176 },
  { label: "Sweden", value: 177 },
  { label: "Switzerland", value: 178 },
  { label: "Syrian Arab Republic", value: 179 },
  { label: "Taiwan, Province of China", value: 180 },
  { label: "Tajikistan", value: 181 },
  { label: "Tanzania, United Republic of", value: 182 },
  { label: "Thailand", value: 183 },
  { label: "Timor-Leste", value: 184 },
  { label: "Togo", value: 185 },
  { label: "Tonga", value: 186 },
  { label: "Trinidad and Tobago", value: 187 },
  { label: "Tunisia", value: 188 },
  { label: "Turkey", value: 189 },
  { label: "Turkmenistan", value: 190 },
  { label: "Tuvalu", value: 191 },
  { label: "Uganda", value: 192 },
  { label: "Ukraine", value: 193 },
  { label: "United Arab Emirates", value: 194 },
  { label: "United Kingdom", value: 195 },
  { label: "United States", value: 196 },
  { label: "Uruguay", value: 197 },
  { label: "Uzbekistan", value: 198 },
  { label: "Vanuatu", value: 199 },
  { label: "Venezuela, Bolivarian Republic of", value: 200 },
  { label: "Viet Nam", value: 201 },
  { label: "Western Sahara", value: 202 },
  { label: "Yemen", value: 203 },
  { label: "Zambia", value: 204 },
  { label: "Zimbabwe", value: 205 }
];

const unsubscribeReasons = {
  ja: [
    { label: "魅力的な賞金のコンペがなかった。", value: 1 },
    { label: "魅力的なデータのコンペがなかった。", value: 2 },
    { label: "コンペの課題が難しかった。", value: 3 },
    { label: "コンペの課題が簡単すぎた。", value: 4 },
    { label: "サービスが使いにくかった。", value: 5 },
    { label: "試しに登録しただけで利用するつもりはなかった。", value: 6 },
    { label: "魅力的な求人がなかった。", value: 7 },
    { label: "その他", value: 99 },
  ],
};

const clientsUnsubscribeReasons = {
  ja: [
    { label: "魅力的な候補者がいなかった。", value: 101 },
    { label: "十分な応募がなかった。", value: 102 },
    { label: "サービスが使いにくかった。", value: 103 },
    { label: "サービスの料金が高かった。", value: 104 },
    { label: "他のサービスを利用することにした。", value: 105 },
    { label: "求人の必要性がなくなった。", value: 106 },
    { label: "試しに登録しただけで広告出稿するつもりはなかった。", value: 107 },
    { label: "その他", value: 99 },
  ],
};

const inquiryTypes = {
  ja: [
    { label: "コンペティション開催のご依頼・ご相談​", value: 1 },
    { label: "求人情報掲載のご依頼・ご相談", value:2 },
    { label: "開催中のコンペティションに関するお問い合わせ​", value: 3 },
    { label: "Nishikaの使い方やシステムに関するお問い合わせ", value: 4 },
    { label: "その他のお問い合わせ​", value: 5 },
  ]
};

const topicSortLogics = {
  ja: [
    { label: "一日のコメント数が多い順", value: 1},
    { label: "コメントが最近ついている順", value: 2}
  ]
};

const jobApplicationStatus = {
  regular: [
    { label: 'マッチング', value: 2},
    { label: '面接', value: 3},
    { label: '内定', value: 4},
    { label: '内定承諾', value: 5},
    { label: 'お見送り/候補者辞退', value: 6},
  ],
  side: [
    { label: 'マッチング', value: 2},
    { label: '契約', value: 5},
    { label: 'お見送り/候補者辞退', value: 6},
  ]
}

const remoteStatuses = {
  ja: [
    { label: 'フルリモート可', value: 1 },
    { label: '一部リモート可', value: 2 },
    { label: 'リモート不可', value: 3 },
  ]
}

const hourlyWageItems = {
  ja: [
    { label: '~1500円', value: 1 },
    { label: '1500円~2500円', value: 2 },
    { label: '2500円~3500円', value: 3 },
    { label: '3500円~4500円', value: 4 },
    { label: '3500円~4500円', value: 5 },
    { label: '4500円~5500円', value: 6 },
    { label: '5500円~6500円', value: 7 },
    { label: '6500円~7500円', value: 8 },
    { label: '7500円~8500円', value: 9 },
    { label: '8500円~9500円', value: 10 },
    { label: '9500円~10500円', value: 11 },
    { label: '10500円~', value: 12 },
  ]
}

const workingHoursWeekItems = {
  ja: [
    { label: '~5時間', value: 1 },
    { label: '5時間~10時間', value: 2 },
    { label: '10時間~15時間', value: 3 },
    { label: '15時間~20時間', value: 4 },
    { label: '20時間~25時間', value: 5 },
    { label: '25時間~30時間', value: 6 },
    { label: '30時間~35時間', value: 7 },
    { label: '35時間~40時間', value: 8 },
    { label: '40時間~', value: 9 },
  ]
}

export {
  areas,
  partners,
  languages,
  countries,
  unsubscribeReasons,
  clientsUnsubscribeReasons,
  inquiryTypes,
  topicSortLogics,
  jobApplicationStatus,
  remoteStatuses,
  hourlyWageItems,
  workingHoursWeekItems,
};
